import { render, staticRenderFns } from "./VSadvert.vue?vue&type=template&id=36e532ae&"
import script from "./VSadvert.vue?vue&type=script&lang=js&"
export * from "./VSadvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports